import React, { useState } from 'react';
import { Logo } from './shared';

const CATEGORIES = [
  ['tubers', 'Dahlia Tubers'],
  ['farmhouse', 'Farmhouse'],
  ['explore', 'Discover Torquay'],
  ['blog', 'Journal'],
  ['contact', 'Contact'],
];

export default function Nav({ page, go }) {
  const [mobile, setMobile] = useState(false);
  const nav = (id, extra = {}) => () => { go(id, extra); setMobile(false); };
  return (
    <>
      <div className={`mobile-nav${mobile ? ' open' : ''}`} id="mobileNav">
        <button className="mobile-nav-close" onClick={() => setMobile(false)}>×</button>
        <button className="nav-link" onClick={nav('home')}>Home</button>
        {CATEGORIES.map(([id, label]) => (
          <button key={id} className={`nav-link${id === 'tubers' ? ' tubers-tab' : ''}`} onClick={nav(id)} data-testid={`mobile-nav-${id}`}>{label}</button>
        ))}
        <button className="nav-link cta" onClick={nav('tubers', { scrollToJoin: true })}>Join the List</button>
      </div>

      <nav className="nav-two-row">
        <div className="nav-row">
          <div></div>
          <button className="nav-logo" onClick={nav('home')}>
            <Logo size="nav" />
          </button>
          <div className="nav-links">
            <button className="nav-link cta" onClick={nav('tubers', { scrollToJoin: true })}>Join the List</button>
          </div>
          <button className="nav-burger" onClick={() => setMobile(true)} aria-label="Menu">
            <span></span><span></span><span></span>
          </button>
        </div>
        <div className="nav-strip" data-testid="nav-strip">
          {CATEGORIES.map(([id, label]) => (
            <button key={id} className={`nav-strip-link${page === id ? ' active' : ''}${id === 'tubers' ? ' tubers-tab' : ''}`} onClick={nav(id)} data-testid={`nav-strip-${id}`}>{label}</button>
          ))}
        </div>
      </nav>
    </>
  );
}
